import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { RatingRoutingModule } from './rating-routing.module';
import { KafTableComponent } from './kaf-table/kaf-table.component';
import { FakulTableComponent } from './fakul-table/fakul-table.component';
import { TeachersComponent } from './teachers/teachers.component';
import { StatisticsComponent } from './statistics/statistics.component';
import { ByIndicatorComponent } from './by-indicator/by-indicator.component';
import { SharedModule } from '../../shared/shared.module';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ChartistModule } from 'ng-chartist';
import { HeaderClickDirective } from './components/directives/header-click.directive';
import { CustomFullscreenDialogComponent } from './components/dialog/custom-fullscreen-dialog.component';
import { TeacherIndexViewModule } from '../teacher-index-view/teacher-index-view.module';

@NgModule({
  declarations: [
    KafTableComponent,
    FakulTableComponent,
    TeachersComponent,
    StatisticsComponent,
    ByIndicatorComponent,
    HeaderClickDirective,
    CustomFullscreenDialogComponent,
  ],
  imports: [
    CommonModule,
    RatingRoutingModule,
    NgxDatatableModule,
    Ng2SmartTableModule,
    SharedModule,
    ChartistModule,
    TeacherIndexViewModule,
  ],
  exports: [HeaderClickDirective, CustomFullscreenDialogComponent],
})
export class RatingModule {}
